import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const FloatingContactButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showContactOptions, setShowContactOptions] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const contactOptions = [
    {
      label: "Call Now",
      icon: "Phone",
      action: () => window.open("tel:+385959048811", "_self"),
      color: "bg-success hover:bg-success/90",
    },
    {
      label: "WhatsApp",
      icon: "MessageCircle",
      action: () => window.open("https://wa.me/385959048811", "_blank"),
      color: "bg-accent hover:bg-accent/90",
    },
    {
      label: "Email",
      icon: "Mail",
      action: () => window.open("mailto:sonja.drglin@gmail.com", "_self"),
      color: "bg-primary hover:bg-primary/90",
    },
  ];

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Contact Options */}
      {showContactOptions && (
        <div className="mb-4 space-y-3 animate-in slide-in-from-bottom-2">
          {contactOptions?.map((option, index) => (
            <button
              key={index}
              onClick={option?.action}
              className={`
                flex items-center space-x-3 ${option?.color} text-white px-4 py-3 rounded-full
                shadow-elevated transition-smooth hover:scale-105 whitespace-nowrap
              `}
            >
              <Icon name={option?.icon} size={18} />
              <span className="font-medium text-sm">{option?.label}</span>
            </button>
          ))}
        </div>
      )}
      {/* Main Contact Button */}
      <Button
        variant="default"
        size="icon"
        onClick={() => setShowContactOptions(!showContactOptions)}
        className={`
          w-14 h-14 rounded-full shadow-elevated hover:scale-110 transition-smooth
          ${
            showContactOptions
              ? "bg-error hover:bg-error/90"
              : "bg-primary hover:bg-primary/90"
          }
        `}
      >
        <Icon
          name={showContactOptions ? "X" : "Phone"}
          size={20}
          className="text-white"
        />
      </Button>
    </div>
  );
};

export default FloatingContactButton;
